exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rewardingform-cssmodule-rewardingform-component-2VdqR{border:1px dashed red;border:none}", ""]);

// exports
exports.locals = {
	"rewardingform-component": "rewardingform-cssmodule-rewardingform-component-2VdqR"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/ProcessIdeas/rewardingform.cssmodule.scss
// module id = 609
// module chunks = 0